import { Model } from "@/models/base/model";

export class Tags extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // タグ一覧取得
  async getAllTags(): Promise<any> {
    this.url = "/cms/api/tags/all";
    return super.fetch();
  }
}
